import Button from 'components/form/Button';
import Modal from 'components/Layout/Modal';
import React, { useState } from 'react';
import { icons } from 'utils/constants';

const PaymentPopup = ({
  onHide,
  setPaymentMethod,
  setAbstractDetails,
  abstractDetails,
}) => {
  const [isOtherPayment, setIsOtherPayment] = useState(false);

  const handlePaymentClick = (value) => {
    if (!abstractDetails?.is_payment_section_visible) {
      const updatedDetails = {
        ...abstractDetails,
        is_payment_section_visible: true,
      };
      setAbstractDetails(updatedDetails);
      setPaymentMethod(value);
      onHide();
      return;
    }
  };
  return (
    <Modal onHide={onHide} title="Choose Payment method">
      {isOtherPayment ? (
        <>
          {/* You can replace this with your actual component or content */}
          <div className="d-flex justify-content-center  gap-3 cpt-30 cpb-30">
            <div>
              <Button
                isRounded
                text="Cash"
                btnStyle="primary-dark"
                className="cps-40 cpe-40"
                onClick={() => handlePaymentClick('cash')}
              />
            </div>
            <div>
              <Button
                isRounded
                text="Other Online Payment Mode"
                btnStyle="primary-outline1"
                className="cps-40 cpe-40"
                onClick={() => handlePaymentClick('other')}
              />
              <div className="d-flex gap-2 text-14-400-18 align-items-center cmt-10">
                <span>
                  <img src={icons.circleInfo} height={20} width={20} />
                </span>
                Apart from the CC Avenue and Paypal
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          className="cps-25 cpe-25 cpt-30 cpb-30"
          style={{ width: '50%', margin: 'auto' }}
        >
          <div>
            <Button
              isRounded
              text="CC Avenue"
              btnStyle="primary-dark"
              className="cps-40 cpe-40"
              onClick={() => handlePaymentClick('ccavenue')}
            />
          </div>
          <div className="text-center cps-40 cpe-40 cmb-5">Available</div>

          <div>
            <Button
              className="btn-paypal"
              isRounded
              text={
                <span className="paypal-text">
                  <strong>Pay</strong>
                  <span style={{ color: '#009cde' }}>Pal</span>
                </span>
              }
              onClick={() => handlePaymentClick('paypal')}
            />
          </div>
          <div className="text-center cps-40 cpe-40 cmb-10">
            The safer, easier way to pay
          </div>

          <div>
            <Button
              isRounded
              text="Other Payment Mode"
              btnStyle="primary-outline1"
              className="cps-40 cpe-40"
              onClick={() => setIsOtherPayment(true)}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default PaymentPopup;
